module.exports = __webpack_public_path__ + "media/images/fr_ca/approach-segment-b64eb75d69bf3c6788496b90242c5be3.jpg";